import React from 'react'
import GiftCardEnterDetails from '../../components/User/GiftCardEnterDetailsPage';

const GiftCardEnterDetailsComp = () => {
  return (
    <GiftCardEnterDetails />
  )
}

export default GiftCardEnterDetailsComp;